
namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class CompaniesDialog extends Serenity.EntityDialog<CompaniesRow, any> {
        protected getFormKey() { return CompaniesForm.formKey; }
        protected getIdProperty() { return CompaniesRow.idProperty; }
        protected getLocalTextPrefix() { return CompaniesRow.localTextPrefix; }
        protected getNameProperty() { return CompaniesRow.nameProperty; }
        protected getService() { return CompaniesService.baseUrl; }
        protected getDeletePermission() { return CompaniesRow.deletePermission; }
        protected getInsertPermission() { return CompaniesRow.insertPermission; }
        protected getUpdatePermission() { return CompaniesRow.updatePermission; }

        protected form = new CompaniesForm(this.idPrefix);

        private usersGrid: CompaniesUserGrid;

        constructor() {
            super();
            SorAraBul.Common.preventAutofill([
                this.form.CityId,
                this.form.IlceId
            ]);

            this.usersGrid = new CompaniesUserGrid(this.byId('UsersGrid'));
            this.usersGrid.openDialogsAsPanel = false; 

            this.byId('UserList').closest('.field').hide().end().appendTo(this.byId('TabCustomer'));
        }


        protected getToolbarButtons()
        {
            let buttons = super.getToolbarButtons();

            //if (!Authorization.hasPermission("Administration:SuperAdmin"))
            //    return buttons;

            if (!Authorization.hasPermission("Administration:SuperAdmin"))
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);     

            return buttons;
        }

        loadEntity(entity: CompaniesRow) {
            super.loadEntity(entity);

            Serenity.TabsExtensions.setDisabled(this.tabs, 'Orders', this.isNewOrDeleted());

            this.usersGrid.companyID = entity.CompanyId;
        }

        getTemplate() {
            return `<div id="~_Tabs" class="s-DialogContent">
    <ul>
        <li><a href="#~_TabInfo"><span>${Q.text("Db.Administration.Companies.EntitySingular")}</span></a></li>
        <li><a href="#~_TabCustomer"><span>${Q.text("Db.Administration.User.EntityPlural")}</span></a></li>
    </ul>
    <div id="~_TabInfo" class="tab-pane s-TabInfo">
        <div id="~_Toolbar" class="s-DialogToolbar">
        </div>
        <div class="s-Form">
            <form id="~_Form" action="">
                <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                    <div id="~_PropertyGrid"></div>
                    <div class="clear"></div>
                </div>
            </form>
        </div>
    </div>
    <div id="~_TabCustomer" class="tab-pane s-TabCustomer">
    <div id="~_UsersGrid">
        </div>
    </div>
</div>`;
        }

    }
}
